import React, {Component} from 'react'
import './styles.scss';

import Settings from '../../../settings';
import Registry from "../../../registry";
import MediaConstraints, {MediaResolutions} from "../../../constraints.js"

import Select from '../UIKit/Select';
import Button from '../UIKit/Button';
import StatusMessage from '../UIKit/StatusMessage';

class CameraOptions extends Component {
    constructor(props) {
        super(props);
        this.reset();
    }

    reset() {
        this.state = { message: "" };
        this.settings = new Settings();

        navigator.mediaDevices.enumerateDevices()
            .then(this.enumerateCameraResolutions.bind(this))
            .then(this.addDevices.bind(this))
    }

    renderWithoutDevices() {
        let lang = Registry.get('locale');
        return (<p className="please_wait">{lang.please_wait}</p>)
    }

    enumerateCameraResolutions(devices) {
        let lang = Registry.get('locale');
        var DefaultConstraints = window.chatNeoConstraints || {};
        let Constraints = new MediaConstraints(DefaultConstraints);

        let actualList =
            Constraints.filter_resolutions(MediaResolutions)
            .map((r) => {
                if (lang["quality__" + r.label]) {
                    r.label = lang["quality__" + r.label]
                } return r;
            });

        for (let i=0; i < devices.length; i++) {
            if (devices[i].kind == "videoinput") {
                devices[i].resolutions = actualList;
            }
        }
        
        return new Promise(function(resolve, reject) {
            resolve(devices);
        });
    }

    addDevices(List) {
        let lang = Registry.get('locale');

        let cameraList = [];
        let micList = [];
        let unknownCameraIndex = 1;
        let unknownMicIndex = 1;

        let label = "";

        for (let i=0; i < List.length; i++) {
            switch (List[i].kind) {
                case "videoinput":
                    label = List[i].label ? List[i].label :
                        lang.camera + " #" + unknownCameraIndex++;
                    cameraList.push(
                        {
                            id: List[i].deviceId,
                            key: List[i].deviceId,
                            label: label,
                            resolutions: List[i].resolutions
                        }
                    );
                    break;

                case "audioinput":
                    label = List[i].label ? List[i].label :
                        lang.microphone + " #" + unknownMicIndex++;
                    micList.push(
                        {
                            id: List[i].deviceId,
                            key: List[i].deviceId,
                            label: label
                        }
                    );
                    break;

                default:
                    break;
            }
        }
        this.setState({
            devicesList: List,
            cameraList,
            micList
        })
    }

    getCamera(DeviceId) {
        for (let i = 0; i < this.state.cameraList.length; i++) {
            if (this.state.cameraList[i].id == DeviceId) return this.state.cameraList[i];
        }

        return false;
    }

    getResolution(CameraDeviceId, ResolutionId) {
        let Camera = this.getCamera(CameraDeviceId);
        for (let i = 0; i < Camera.resolutions.length; i++) {
            if (Camera.resolutions[i].key == ResolutionId) return Camera.resolutions[i];
        }

        return false;
    }

    applyDevices() {
        let chatInterface = Registry.get('chatInterface');

        let CameraDeviceId = this.state.cameraListRef.value();
        let MicDeviceId = this.state.micListRef.value();

        let ResolutionId = this.state.resolutionListRef.value();
        this.trackQualityChange(ResolutionId);

        let Resolution = this.getResolution(CameraDeviceId, ResolutionId);

        var DefaultConstraints = window.chatNeoConstraints || {};

        let Constraints = (new MediaConstraints(DefaultConstraints))
            .set_device_id("video", CameraDeviceId)
            .set_device_id("audio", MicDeviceId)
            .set_resolution(Resolution);

        if (this.state.voiceProcessingRef) {
            let voice_processing = this.state.voiceProcessingRef.value() === "voice";
            Constraints.enable_audio_processing(voice_processing);
            this.settings.set("media.voice_processing", this.state.voiceProcessingRef.value());
        }
        var _this = this;

        chatInterface.hitagi.media.switch_devices(Constraints)
            .then(function(event) {
                // Successfull switch, so save new devices ids, if requested
                if (true) {
                    _this.settings.set("media.camera", CameraDeviceId);
                    _this.settings.set("media.resolution", Resolution);
                    _this.settings.set("media.mic", MicDeviceId);
                } else {
                    _this.settings.set("media.camera", false);
                    _this.settings.set("media.resolution", false);
                    _this.settings.set("media.mic", false);
                }

                // And call onSuccess callback
                _this.onSuccess();
            })
            .catch(function(event) {
                _this.setState({
                    status: "error",
                    message: "failed_streaming"
                });
            })
    }

    trackQualityChange(ResolutionId) {

        let dl = window.dataLayer || [];

        dl.push({
            'event': 'streamQualitySet',
            'eventCategory': 'stream',
            'eventAction': 'streamQualitySet',
            'eventLabel': ResolutionId
        });

    }

    onSuccess() {
        this.setState({
            status: "success",
            message: ""
        });
        if (this.props.onSuccess) {
            this.props.onSuccess();
        }
    }

    onCancel() {
        if (this.props.onCancel) {
            this.props.onCancel();
        }
    }

    renderVoiceProcessingControl() {
        let chatInterface = Registry.get("chatInterface");
        if (!chatInterface) return null;

        if (!chatInterface.can("voice_processing")) return null;

        let lang = Registry.get('locale');

        let voiceProcessing = this.settings.get("media.voice_processing");
        if (voiceProcessing !== 'music') {
            voiceProcessing = 'voice';
        }
        let voiceProcessingList = [
            {
                id: 0,
                key: "music",
                label: lang.music,
            },
            {
                id: 1,
                key: "voice",
                label: lang.voice,
            }
        ];

        return (<Select name="AudioFilter" label={lang.audio_filter} value={voiceProcessing} options={voiceProcessingList} ref={(ref) => {this.state.voiceProcessingRef = ref}} />);
    }

    render() {
        let chatInterface = Registry.get("chatInterface");
        if (!this.state.devicesList) {
            return this.renderWithoutDevices();
        }
        let cameraList = this.state.cameraList;
        let micList = this.state.micList;

        let cameraSelected = this.settings.get("media.camera")
        let micSelected = this.settings.get("media.mic")

        let resolutionList = cameraList.length > 0 ? cameraList[0].resolutions : [];

        let resolutionSelected = this.settings.get("media.resolution") ?  this.settings.get("media.resolution").key : "480p";

        try {
            cameraSelected = chatInterface.hitagi.media.getDeviceId("video");
            micSelected = chatInterface.hitagi.media.getDeviceId("audio");
        } catch (e) {
            console.log("No support of Hitagi.media.getDeviceId")
        }

        let message = null;
        let lang = Registry.get('locale');

        if (this.state.message) {
            message = <StatusMessage type={this.state.status}
                          text={lang[this.state.message]}/>
        }

        let voiceProcessingControl = this.renderVoiceProcessingControl();

        return (
            <div className="settings-tab CameraOptions">
                <div className="options">
                {message}
                    <form>
                        <Select name="Camera" label={lang.camera} value={cameraSelected} options={cameraList} ref={(ref) => {this.state.cameraListRef = ref}} />
                        <Select name="Resolution" label={lang.quality} value={resolutionSelected} options={resolutionList} ref={(ref) => {this.state.resolutionListRef = ref}} />
                        <p>{lang.quality_description}</p>
                        <Select name="Microphone" label={lang.microphone} value={micSelected} options={micList} ref={(ref) => {this.state.micListRef = ref}} />

                        {voiceProcessingControl}
                    </form>
                </div>
                <div className="bottom">
                    <Button text={lang.apply} default onClick={this.applyDevices.bind(this)}/>
                </div>
            </div>
        );
    }
}

export default CameraOptions;



// WEBPACK FOOTER //
// ./src/components/bobtv-neo/CameraOptions/index.js